<app-stepper-form
  header="Change of Ultimate Holding Company"
  subheader="Form 484A3"
  formIcon="ic-сhange-of-ultimate-holding-company-20"
  [showSteps]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [form]="stepperForm"
>
  <div class="step-content" [formGroup]="stepperForm">
    <app-stepper-form-description
      formKey="484 A3"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [formGroupName]="StepsEnum.ChangeHoldingCompany"
      [hidden]="currentStep !== StepsEnum.ChangeHoldingCompany"
    >
      <h1 class="h1-heading">Change of Ultimate Holding Company</h1>

      <div class="form-group">
        <app-select
          label="The Change is"
          formControlName="action"
          [options]="changeDescriptionOptions"
          [valuePrimitive]="true"
        />
      </div>

      <div class="form-group" [hidden]="hideDataPart">
        <app-flags-autocomplete
          label="Place of incorporation of Ultimate Holding Company"
          formControlName="holdingCompanyPlaceOfIncorporation"
        />
      </div>

      <div class="form-group">
        <app-date-picker
          label="Date of Change"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      @if (lateFeeMessage) {
        <app-disclaimer
          color="red"
          icon="ic-info-circle-20"
        >
          {{ lateFeeMessage }}
        </app-disclaimer>
      }

      <div
        class="form-group"
        [hidden]="hideAustralianCompanyNameAcn"
        [formGroup]="form"
      >
        <app-company-name-acn-form-group
          nameTitle="Ultimate Holding Company Name"
          acnTitle="Ultimate Holding Company ACN"
          [formGroup]="form"
          [shouldLookForCompanyName]="isOverseasCompany"
          (companySelected)="onCompanySelected($event)"
        />
      </div>

      <div class="form-group" [hidden]="hideAboardCompanyName">
        <app-input
          label="Ultimate Holding Company Name"
          formControlName="aboardCompanyName"
        />
      </div>

      @if (errorMessage) {
        <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
      }
    </section>
  </div>
</app-stepper-form>
